import {
  IPrismicProductReinsurance,
  IProduct,
  PrismicLinkContext,
} from '@monofront/types';
import { useMediaQuery, useProductLayout } from '@monofront/business/hooks';
import ListBox, {
  IListBoxLine,
} from '@monofront/design-system/components/ListBox';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { useEditorialSidePanelContext } from '@monofront/business/contexts';
import { useTagContextMatches } from '@hooks/businessContainer';

interface IProductReinsuranceProps {
  product: IProduct;
}

const ProductReinsurance: React.FC<IProductReinsuranceProps> = ({
  product,
}) => {
  const { productLayout } = useProductLayout();
  const { setEditorialPanelSourceUid } = useEditorialSidePanelContext();
  const isMobile = useMediaQuery(800);
  const reinsurances = productLayout.reinsurance;
  let bgColor = productLayout.reinsurance_background_color;
  const { tagContextMatches } = useTagContextMatches({ isWebMobile: isMobile });

  const formatReasuranceLine = (
    reinsurance: IPrismicProductReinsurance,
  ): IListBoxLine<string> => {
    return {
      illustration: reinsurance.icon?.url ? (
        <ResponsiveImage src={reinsurance.icon?.url} layout="fill" />
      ) : undefined,
      text: reinsurance.label!,
      prismicLink: reinsurance.link,
    };
  };

  const filteredReinsurance = reinsurances?.reduce<IListBoxLine<string>[]>(
    (reinsuranceList, reinsurance) => {
      if (!reinsurance.label) return reinsuranceList;

      if (reinsurance.condition) {
        const matchCondition = tagContextMatches(reinsurance.condition, {
          tags: { product: product.tags },
        });

        if (!matchCondition) return reinsuranceList;
      }

      bgColor = reinsurance.forced_background_color
        ? reinsurance.forced_background_color
        : bgColor;

      return [...reinsuranceList, formatReasuranceLine(reinsurance)];
    },
    [],
  );

  if (!filteredReinsurance || filteredReinsurance.length === 0) {
    return null;
  }

  return (
    <ListBox
      content={{
        lines: filteredReinsurance,
      }}
      openSidePanel={(uid) => {
        if (uid) setEditorialPanelSourceUid(uid);
      }}
      context={PrismicLinkContext.SHOP}
      bgColor={bgColor || undefined}
      UNSAFE_className={`tw-mt-5 tw-max-w-[462px]`}
    />
  );
};

export default ProductReinsurance;
